var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgLogoText = function SvgLogoText(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 50,
    viewBox: "0 0 149 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_885_8448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.7875 32.1141C80.7875 21.8305 88.3742 14.228 98.4387 14.228C108.503 14.228 116.019 21.8901 116.019 32.1141C116.019 42.3381 108.491 50.0002 98.3679 50.0002C88.2444 50.0002 80.7875 42.4692 80.7875 32.1141ZM110.769 32.1141C110.769 24.5831 105.648 18.9468 98.3797 18.9468C91.1116 18.9468 86.0498 24.6427 86.0498 32.1141C86.0498 39.5855 91.1706 45.2814 98.3797 45.2814C105.589 45.2814 110.769 39.7166 110.769 32.1141Z",
    fill: "url(#paint0_linear_885_8448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.35964 38.8584V19.459H0V15.0739H5.06175C5.97027 15.0739 6.69001 14.4781 6.69001 13.3699V5.18351H11.4922V15.0739H21.8753V19.459H11.4922V38.7869C11.4922 42.4571 12.8609 44.6139 16.7427 44.6139H21.4151V49.1301H16.4241C10.1943 49.1301 6.37144 45.7221 6.37144 38.8465L6.35964 38.8584ZM27.055 32.1139C27.055 21.2345 34.3822 14.2278 43.5972 14.2278C53.8504 14.2278 59.9505 21.8303 59.9505 31.6611V33.949H32.4353C32.6949 40.765 37.0369 45.2812 43.9865 45.2812C48.4583 45.2812 52.7413 43.1244 54.2988 39.1206H59.6201C57.7441 45.4719 51.8328 50 43.9157 50C33.6034 50 27.0432 42.3379 27.0432 32.1139H27.055ZM54.5112 29.3613C54.051 22.5453 49.3196 18.9466 43.6089 18.9466C37.8983 18.9466 33.0961 23.0696 32.5769 29.3613H54.5112ZM67.1007 41.8732V0H72.2214V41.8732C72.2214 43.5772 73.0591 44.5543 74.6874 44.5543H76.2449V49.142H73.7789C69.5548 49.142 67.0889 46.5205 67.0889 41.8732H67.1007ZM121.871 39.2517H126.874C127.452 43.3151 130.308 45.4719 135.24 45.4719C140.172 45.4719 143.086 42.9814 143.086 39.5138C143.086 29.9452 122.91 37.2259 122.91 23.725C122.91 17.9576 128.03 14.2278 135.11 14.2278C141.34 14.2278 146.531 17.898 147.05 24.0586H142.118C141.67 20.8413 139.263 18.6845 134.791 18.6845C130.567 18.6845 127.854 20.7817 127.854 23.725C127.854 32.3761 148.101 25.1668 148.101 39.2517C148.101 45.6744 142.838 50 134.992 50C127.146 50 122.473 45.6149 121.883 39.2517H121.871Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_885_8448",
    x1: 85.5,
    y1: 19.5002,
    x2: 109.5,
    y2: 50.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#4FACFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#C471F5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_885_8448"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 148.077,
    height: 50,
    fill: "white"
  })))));
};
export default SvgLogoText;